import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseInput from 'flow/components/ui-components/BaseInput';
import AppContext from 'flow/contexts/app-context';
import { isValidSaveableNumber } from 'flow/utils/call-utils';
import { Map } from 'immutable';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import PropTypes from 'prop-types';
import React from 'react';
import PhoneNumberInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './css/phoneInputCountry.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var InputComponent = /*#__PURE__*/React.forwardRef(function InputComponent(props, ref) {
  var value = props.value,
    onChange = props.onChange;
  return /*#__PURE__*/_jsx(BaseInput, {
    value: value,
    onChange: onChange,
    ref: ref,
    noMarginTop: true
  });
});
InputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};
var NumberFieldSmart = /*#__PURE__*/function (_React$PureComponent) {
  function NumberFieldSmart(props) {
    var _this;
    _classCallCheck(this, NumberFieldSmart);
    _this = _callSuper(this, NumberFieldSmart, [props]);
    _defineProperty(_this, "handleNumberChangeSmart", function (phoneNumber) {
      var onChange = _this.props.onChange;
      _this.setState({
        enteredNumber: phoneNumber,
        numberIsValid: isValidSaveableNumber(phoneNumber)
      });
      if (onChange && isValidSaveableNumber(phoneNumber)) {
        onChange(_this.props.id, phoneNumber);
      }
    });
    _defineProperty(_this, "handleNumberChange", function (event) {
      var onChange = _this.props.onChange;
      _this.setState({
        enteredNumber: event.target.value,
        numberIsValid: isValidSaveableNumber(event.target.value)
      });
      if (onChange && isValidSaveableNumber(event.target.value)) {
        onChange(_this.props.id, event.target.value);
      }
    });
    _defineProperty(_this, "numberFieldFocused", function () {
      _this.setState({
        indicateInvalid: false
      });
    });
    var numberDTO = props.numberDTO;
    var number = numberDTO ? numberDTO.get('number', '') : '';

    //Superduper naive check
    var isShortNumber = numberDTO && numberDTO.get('type') === 'missing_context' && numberDTO.get('nationalFormat') && numberDTO.get('nationalFormat').length <= 5;

    //Naive approach to formatting numbers for a few select countries.
    var formattedNumber = number.replace(/^00(358|41|44|45|46|47|97)/, '+$1');
    _this.state = {
      enteredNumber: formattedNumber,
      indicateInvalid: false,
      isShortNumber: isShortNumber,
      numberIsValid: isValidSaveableNumber(formattedNumber)
    };
    return _this;
  }
  _inherits(NumberFieldSmart, _React$PureComponent);
  return _createClass(NumberFieldSmart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        onBlur = _this$props.onBlur,
        disabled = _this$props.disabled,
        label = _this$props.label,
        defaultCountryCode = _this$props.defaultCountryCode,
        numberDTO = _this$props.numberDTO;
      var _this$state = this.state,
        enteredNumber = _this$state.enteredNumber,
        numberIsValid = _this$state.numberIsValid,
        isShortNumber = _this$state.isShortNumber;
      var i18next = this.context.i18next;
      var defaultValue = enteredNumber;
      var shouldDisplayInternationlOption = (numberDTO === null || numberDTO === void 0 ? void 0 : numberDTO.get('type')) === 'missing_context';
      var errorText = numberIsValid ? '' : i18next.t('fields.phonenumber.format.error');
      var hintText = i18next.t('InviteColleagues.TokenField.Input');
      var fieldLabel = label ? label : null;
      if (disabled || isShortNumber) {
        var numberFieldProps = {
          defaultValue: defaultValue,
          disabled: disabled,
          error: !!errorText,
          placeholder: disabled ? '' : hintText,
          id: id,
          onBlur: onBlur,
          fullWidth: true,
          onChange: this.handleNumberChange,
          label: fieldLabel
        };
        return /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col justify-center gap-1",
          children: [/*#__PURE__*/_jsx(BaseInput, _objectSpread({
            dir: "ltr",
            className: "rtl:text-end"
          }, numberFieldProps)), errorText ? /*#__PURE__*/_jsx("p", {
            className: "text-sm text-gray-500",
            children: errorText
          }) : null]
        });
      }
      var countryCode = undefined;
      if (numberDTO && numberDTO.get('number')) {
        var parsedNumber = defaultValue ? parsePhoneNumberFromString(defaultValue) : null;
        countryCode = numberDTO.get('countryCode') ? numberDTO.get('countryCode') : defaultValue && parsedNumber && parsedNumber.isValid() ? parsedNumber.country.toUpperCase() : undefined;
      } else {
        countryCode = defaultCountryCode !== undefined ? defaultCountryCode.toUpperCase() : undefined;
      }
      return /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col justify-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "block text-start text-xs/6 text-gray-900",
          children: fieldLabel
        }), /*#__PURE__*/_jsx("div", {
          className: "PhoneNumberParent",
          children: /*#__PURE__*/_jsx(PhoneNumberInput, {
            placeholder: hintText,
            value: defaultValue,
            defaultCountry: countryCode,
            disabled: disabled,
            onChange: this.handleNumberChangeSmart,
            onFocus: this.numberFieldFocused,
            inputComponent: InputComponent,
            addInternationalOption: shouldDisplayInternationlOption
          })
        })]
      });
    }
  }]);
}(React.PureComponent);
_defineProperty(NumberFieldSmart, "propTypes", {
  id: PropTypes.string,
  numberDTO: PropTypes.instanceOf(Map),
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  defaultCountryCode: PropTypes.string
});
_defineProperty(NumberFieldSmart, "contextType", AppContext);
export default NumberFieldSmart;